import script from "./select-boom.vue?vue&type=script&lang=ts&setup=true"
export * from "./select-boom.vue?vue&type=script&lang=ts&setup=true"

import "./select-boom.vue?vue&type=style&index=0&id=5f96f2ef&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f96f2ef"]])

export default __exports__